import {
    FETCH_TEAM_DATA_REQUEST,
    FETCH_TEAM_DATA_SUCCESS,
    FETCH_TEAM_DATA_FAILURE,
    ADD_TEAM_DATA_REQUEST,
    ADD_TEAM_DATA_SUCCESS,
    ADD_TEAM_DATA_FAILURE,
    UPDATE_TEAM_DATA_REQUEST,
    UPDATE_TEAM_DATA_SUCCESS,
    UPDATE_TEAM_DATA_FAILURE,
    DELETE_TEAM_DATA_REQUEST,
    DELETE_TEAM_DATA_SUCCESS,
    DELETE_TEAM_DATA_FAILURE,
    TOGGLE_ACTIVE_REQUEST,
    TOGGLE_ACTIVE_SUCCESS,
    TOGGLE_ACTIVE_FAILURE,
} from './actionType';

export const fetchTeamDataRequest = (payload) => ({
    type: FETCH_TEAM_DATA_REQUEST,
    payload,
});

export const fetchTeamDataSuccess = (teamData) => ({
    type: FETCH_TEAM_DATA_SUCCESS,
    payload: teamData,
});

export const fetchTeamDataFailure = (error) => ({
    type: FETCH_TEAM_DATA_FAILURE,
    payload: error,
});

export const addTeamDataRequest = (payload) => ({
    type: ADD_TEAM_DATA_REQUEST,
    payload,
});

export const addTeamDataSuccess = (teamData) => ({
    type: ADD_TEAM_DATA_SUCCESS,
    payload: teamData,
});

export const addTeamDataFailure = (error) => ({
    type: ADD_TEAM_DATA_FAILURE,
    payload: error,
});

export const updateTeamDataRequest = (payload) => ({
    type: UPDATE_TEAM_DATA_REQUEST,
    payload,
});

export const updateTeamDataSuccess = (teamData) => ({
    type: UPDATE_TEAM_DATA_SUCCESS,
    payload: teamData,
});

export const updateTeamDataFailure = (error) => ({
    type: UPDATE_TEAM_DATA_FAILURE,
    payload: error,
});

export const deleteTeamDataRequest = (payload) => ({
    type: DELETE_TEAM_DATA_REQUEST,
    payload,
});

export const deleteTeamDataSuccess = (team) => ({
    type: DELETE_TEAM_DATA_SUCCESS,
    payload: team,
});

export const deleteTeamDataFailure = (error) => ({
    type: DELETE_TEAM_DATA_FAILURE,
    payload: error,
});

export const toggleActiveRequest = (payload) => ({
    type: TOGGLE_ACTIVE_REQUEST,
    payload,
});

export const toggleActiveSuccess = (id, isActive) => ({
    type: TOGGLE_ACTIVE_SUCCESS,
    payload: { id, isActive },
});

export const toggleActiveFailure = (error) => ({
    type: TOGGLE_ACTIVE_FAILURE,
    payload: error,
});